import { ItemList } from '../orm'

class CustomerProfileList extends ItemList {
    getEntityKey() {
      return "customer/editprofile"
    }
    
}

export const customerProfileList = new CustomerProfileList("customer_profile_default")